import api from './api'

const GetBookingRequestDetails = () => api.get('/BookingRegister/GetBookingRequestDetails')

const GetRequestVehicleDetails = () => api.get('/VehicleDetails/GetRequestVehicleDetails')

const PostForkBooking = (payload) => api.post('/BookingRegister/PostForkBooking', payload)

const GetVehicleAlreadyInfo = (vehicleId, startTime, endTime) =>
    api.get('/BookingRegister/GetVehicleAlreadyInfo', {
        params: {
            vehicle_id: vehicleId,
            booking_start_time: startTime,
            booking_end_time: endTime,
        }
    })

// POST cancel
const PostBookingRequestStatus = (reqId) =>
    api.post('https://aeroviewbackend.dockyardsoftware.com/BookingRegister/PostBookingRequestStatus', [
        {
            status: "C",
            reqId: reqId
        }
    ])


const GetMainForkBookingDetails = () => api.get('/BookingRegister/GetMainForkBookingDetails')

const AdminBookingRequestService = {
    GetBookingRequestDetails,
    GetRequestVehicleDetails,
    PostForkBooking,
    GetVehicleAlreadyInfo,
    PostBookingRequestStatus,
     GetMainForkBookingDetails,
}

export default AdminBookingRequestService